import { useEffect, useState } from 'react'

import { Nullable } from 'models/helpers'
import { PreferredPaymentMethodType } from 'models/user'

import { offersPreferredPaymentMethodChoice } from './preferredPaymentMethodChoice'

/**
 * {@link offersPreferredPaymentMethodChoice}, kept on once the choice has been offered on this page, so a client
 * who replaces an unavailable saved method still sees the selector and its saved confirmation.
 */
export function useOffersPreferredPaymentMethodChoice(
  availableMethods: ReadonlyArray<PreferredPaymentMethodType>,
  savedMethod: Nullable<PreferredPaymentMethodType> | undefined
): boolean {
  const offeredNow = offersPreferredPaymentMethodChoice(availableMethods, savedMethod)
  const [wasOffered, setWasOffered] = useState(offeredNow)

  useEffect(() => {
    if (offeredNow) setWasOffered(true)
  }, [offeredNow])

  return offeredNow || wasOffered
}
